export const TENANT_STORAGE_KEY = "x-tenant-id";
export const DEFAULT_TENANT_ID = import.meta.env.VITE_TENANT_ID ?? "";
